import React from 'react';
import "../GuidedExperience/GuidedExperienceWizard.css";
import { useTranslation } from 'react-i18next';
import RadioButton from '../common/RadioGroup/RadioButton';

interface AffordableHousingWizardProps {
    setHasAffordableHousingFlag: (value: boolean) => void;
    setShowRollDownWarning: (value: boolean) => void;
    setShowAffordableHousingQuestion: (value: boolean) => void;
    unitData: Record<string, unknown>[];
    rolldownUnitConfirmAction: () => void;
}

export default function AffordableHousingWizard(props: AffordableHousingWizardProps): JSX.Element {
    const { t } = useTranslation("guided_wizard");
    const handleSelection = (value: boolean) => {
        if (value && props.unitData.length > 0) {
            props.setShowRollDownWarning(true)
        } else if (value) {
            props.rolldownUnitConfirmAction()
        } else {
            props.setHasAffordableHousingFlag(value)
            props.setShowAffordableHousingQuestion(false);
        }
    }
    return (<div>
        <div className='wizard-radio-cell wizard-question'>
            <fieldset>
                <legend>{t("multires-wizard.affordable-housing")}</legend>
                <RadioButton name="affordable-housing-question" id="affordable-housing-question-yes" text={t("yes")} textPosition='right' value="true" currentValue="" onChange={() => handleSelection(true)} />
                <RadioButton name="affordable-housing-question" id="affordable-housing-question-no" text={t("no")} textPosition='right' value="false" currentValue="" onChange={() => handleSelection(false)} />
            </fieldset>
        </div>
    </div>)
}